import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityReport4det } from "../../entity/EntityReport4det";

export class DtoReport4detsGetReq extends EntityReport4det {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_report_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
